import { Button, Divider, Input, Select, SelectItem, Textarea } from '@nextui-org/react'
import { Icon } from '@iconify/react'

export default function CoverPageContentDetails({ onClose, coverPageDetails }) {
  const {
    documentDate,
    setDocumentDate,
    title,
    setTitle,
    createdBy,
    setCreatedBy,
    proposedTo,
    setProposedTo,
    updateCoverPageDetails,
    logo,
    logoSize,
    open,
    deleteFile,
    getRootProps,
    getInputProps,
    coverPageDesign,
    setCoverPageDesign,
    setLogoSize,
    documentProjectID,
    setDocumentProjectID,
  } = coverPageDetails

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-col sticky top-0 bg-white z-[100] h-[60px] rounded">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-medium">Cover Page Details</h2>
          <Button isIconOnly variant="light" onPress={onClose} size="sm">
            <Icon icon="ic:round-close" className="text-gray-500 text-xl" />
          </Button>
        </div>
        <Divider className="my-2 h-[3px]" />
      </div>

      <div className="flex flex-col justify-between items-center mb-4 gap-4">
        <div className="flex flex-col w-full gap-8">
          <Input
            variant="faded"
            value={documentDate}
            label="Document Date"
            placeholder="e.g. March 20th, 2025"
            labelPlacement="outside"
            onChange={(e) => setDocumentDate(e.target.value)}
            onBlur={updateCoverPageDetails}
            classNames={{
              inputWrapper: 'pl-2 border-0',
              label: 'text-sm uppercase !text-gray-500',
            }}
          />
          <Input
            variant="faded"
            value={documentProjectID}
            label="Project ID"
            placeholder="e.g. 199258-2025"
            labelPlacement="outside"
            onChange={(e) => setDocumentProjectID(e.target.value)}
            onBlur={updateCoverPageDetails}
            classNames={{
              inputWrapper: 'pl-2 border-0',
              label: 'text-sm uppercase !text-gray-500',
            }}
          />
          <Textarea
            variant="faded"
            value={title}
            label="Title"
            labelPlacement="outside"
            onChange={(e) => setTitle(e.target.value)}
            onBlur={updateCoverPageDetails}
            classNames={{
              inputWrapper: 'pl-2 border-0',
              label: 'text-sm uppercase !text-gray-500',
            }}
            maxRows={5}
          />
          <Textarea
            variant="faded"
            label="Prepared by"
            labelPlacement="outside"
            value={createdBy}
            onChange={(e) => setCreatedBy(e.target.value)}
            onBlur={updateCoverPageDetails}
            classNames={{
              inputWrapper: 'pl-2 border-0',
              label: 'text-sm uppercase !text-gray-500',
            }}
            maxRows={5}
          />
          <Textarea
            variant="faded"
            label="Prepared for"
            labelPlacement="outside"
            value={proposedTo}
            onChange={(e) => setProposedTo(e.target.value)}
            onBlur={updateCoverPageDetails}
            classNames={{
              inputWrapper: 'pl-2 border-0',
              label: 'text-sm uppercase !text-gray-500',
            }}
            maxRows={5}
          />
          <div {...getRootProps({ className: 'flex flex-col gap-2 mt-2' })}>
            <input {...getInputProps()} />
            <h3 className="text-sm uppercase !text-gray-500">Logo</h3>
            <div className="flex flex-col gap-1 justify-center items-center p-4 border-1 border-secondary rounded-xl">
              {logo ? (
                <>
                  <img src={logo} className="w-[120px] mb-5" />
                  <div className="flex gap-2">
                    <Button variant="solid" color="secondary" onPress={open}>
                      Select file
                    </Button>
                    <Button variant="bordered" color="danger" onPress={deleteFile}>
                      Delete File
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <p className="font-medium text-xl">Select a file or drag and drop here</p>
                  <span className="text-sm font-regular">JPG or PNG, file size no more than 10MB</span>
                  <Button variant="solid" color="secondary" onPress={open}>
                    Select file
                  </Button>
                </>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2 mt-2">
            <h3 className="text-sm uppercase !text-gray-500">Logo Size</h3>
            <div className="flex flex-col gap-1 justify-center items-center">
              <Select
                className="max-w-xs"
                label="Select Logo Size"
                onChange={(e) => {
                  setLogoSize?.(e.target.value)
                }}
                selectedKeys={[logoSize]}
              >
                <SelectItem key={'sm'}>Normal</SelectItem>
                <SelectItem key={'md'}>Medium</SelectItem>
                <SelectItem key={'lg'}>Large</SelectItem>
              </Select>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
